import React from 'react';
import { format } from 'date-fns';
import Button from '../../../components/ui/Button';
import StatusIndicator from '../../../components/ui/StatusIndicator';
import Icon from '../../../components/AppIcon';

const DayDetailsPanel = ({ isOpen, onClose, date, invoices, dateBasis, onOpenInvoice }) => {
  if (!isOpen) return null;

  const formatCurrency = (value, currency = 'GBP') => {
    const n = Number(value || 0);
    if (!Number.isFinite(n)) return '£0.00';
    if (currency === 'USD') return `$${n.toFixed(2)}`;
    if (currency === 'EUR') return `€${n.toFixed(2)}`;
    return `£${n.toFixed(2)}`;
  };

  const title = date
    ? dateBasis === 'created_at'
      ? `Uploads for ${format(date, 'EEE, do MMM')}`
      : `Invoices dated ${format(date, 'EEE, do MMM')}`
    : 'Day Details';

  return (
    <div className="fixed inset-0 z-50 flex">
      <div className="flex-1 bg-black/30" onClick={onClose} />
      <div className="w-full sm:w-1/2 lg:w-1/3 h-full bg-card border-l border-border shadow-xl flex flex-col">
        <div className="p-4 border-b border-border flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Icon name="Calendar" size={18} className="text-primary" />
            <div>
              <h3 className="text-base font-semibold text-foreground">{title}</h3>
              <p className="text-xs text-muted-foreground">
                {invoices?.length || 0} invoice{invoices?.length === 1 ? '' : 's'}
              </p>
            </div>
          </div>
          <Button variant="ghost" size="sm" onClick={onClose} iconName="X" />
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {invoices?.length ? (
            invoices.map((inv) => {
              const badgeStatus = inv?.status === 'exported'
                ? 'reviewed'
                : inv?.status === 'parsed'
                  ? 'needs_review'
                  : inv?.status;
              return (
              <div
                key={inv?.id}
                className="bg-background border border-border rounded-lg p-3 flex items-center justify-between gap-3"
              >
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground truncate">
                    {inv?.vendorName || 'Unknown Vendor'}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {inv?.invoiceNumber ? `Invoice ${inv?.invoiceNumber}` : 'Invoice'}
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <StatusIndicator status={badgeStatus} size="sm" />
                  <div className="text-sm font-mono text-foreground min-w-[90px] text-right">
                    {formatCurrency(inv?.netAmount, inv?.currency)}
                  </div>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => onOpenInvoice?.(inv?.id)}
                  >
                    Review
                  </Button>
                </div>
              </div>
            );
          })
          ) : (
            <div className="text-sm text-muted-foreground bg-muted/40 border border-dashed border-border rounded-lg p-6 text-center">
              No invoices for this day.
            </div>
          )}
        </div>

        <div className="p-4 border-t border-border">
          <Button variant="outline" className="w-full" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DayDetailsPanel;
